import * as React from "react";
export const DragIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask fill="white" id="path-1-inside-1_1168_1313">
      <path d="M2 2H22V22H2V2Z" />
    </mask>
    <path d="M22 22V21H2V22V23H22V22Z" fill="#EAECF0" mask="url(#path-1-inside-1_1168_1313)" />
    <path d="M12 3.00006V9.00006" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    <path d="M3 12.0001H9" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    <path d="M21 12.0001H15" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    <path d="M12 21.0001V14.5001" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    <path
      d="M9 6L10.705 4.04824C11.3155 3.34941 11.6207 3 12 3C12.3793 3 12.6845 3.34941 13.295 4.04824L15 6"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M15 18L13.295 19.9518C12.6845 20.6506 12.3793 21 12 21C11.6207 21 11.3155 20.6506 10.705 19.9518L9 18"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M18 9L19.9518 10.705C20.6506 11.3155 21 11.6207 21 12C21 12.3793 20.6506 12.6845 19.9518 13.295L18 15"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M6 15L4.04824 13.295C3.34941 12.6845 3 12.3793 3 12C3 11.6207 3.34941 11.3155 4.04824 10.705L6 9"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
